module.exports = "/src/views/eternal-dev/businesses/gas-station/images/light/GlobeOil/logo.svg";